import type { RequestMeta } from "@types";

export async function resolveAndMapFallbackDataAsync<
  T extends RequestMeta<any, never, never>[],
>(...params: T) {
  const res = await Promise.all(params.map((m) => m.fetch()));

  const out: { [key: string]: any } = Object.create(null);

  for (let i = 0; i < params.length; i++) {
    out[params[i].key()] = res[i];
  }

  return out;
}
